import { useContext } from 'react';

import { AuthContext } from '../contexts/AuthContext';
import type { AuthContextValue } from '../types/auth';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
